// Converts an uploaded .docx into Markdown. mammoth (docx → HTML) and
// turndown (HTML → Markdown) are imported lazily so they stay out of the
// main bundle and only load when someone actually uploads a file.

export interface DocxConversion {
  markdown: string;
  warnings: string[];
}

export async function docxToMarkdown(file: File): Promise<DocxConversion> {
  const [{ default: mammoth }, { default: turndownService }] =
    await Promise.all([import("mammoth/mammoth.browser"), import("turndown")]);

  const arrayBuffer = await file.arrayBuffer();
  const { value: html, messages } = await mammoth.convertToHtml({
    arrayBuffer,
  });

  const turndown = new turndownService({
    headingStyle: "atx",
    bulletListMarker: "-",
    codeBlockStyle: "fenced",
  });

  const markdown = turndown.turndown(html).trim();
  const warnings = messages
    .filter((m) => m.type === "warning")
    .map((m) => m.message);
  return { markdown: `${markdown}\n`, warnings };
}
